import React, { useEffect, useRef, useState } from 'react';
import styles from '../../styles/InstitucionesStyles/PantallaDeInstituciones.module.css';

const defaultForm = {
  nombre: '',
  clave: '',
  telefono: '',
  email: '',
  direccion: '',
  estado: 'ACTIVO',
  logo: null,
};

export default function NewInstitutionModal({ open, onClose, onSubmit, initialData }) {
  const [form, setForm] = useState(initialData ? {
    nombre: initialData.name || '',
    clave: initialData.clave || '',
    telefono: initialData.telefono || '',
    email: initialData.email || '',
    direccion: initialData.direccion || '',
    estado: initialData.estado || 'ACTIVO',
    logo: initialData.logo || null,
  } : defaultForm);
  const [logoPreview, setLogoPreview] = useState(null);
  const dialogRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (open) {
      if (initialData) {
        setForm({
          nombre: initialData.name || '',
          clave: initialData.clave || '',
          telefono: initialData.telefono || '',
          email: initialData.email || '',
          direccion: initialData.direccion || '',
          estado: initialData.estado || 'ACTIVO',
          logo: initialData.logo || null,
        });
      } else {
        setForm(defaultForm);
      }
      const first = dialogRef.current?.querySelector('input, select, textarea, button');
      first?.focus();
    }
  }, [open, initialData]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  // Manage logo preview (must be before any conditional return for hooks rule)
  useEffect(() => {
    if (form.logo) {
      const url = URL.createObjectURL(form.logo);
      setLogoPreview(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setLogoPreview(null);
    }
  }, [form.logo]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (file) setForm(f => ({ ...f, logo: file }));
  };


  const handleClearLogo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setForm(f => ({ ...f, logo: null }));
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit?.(form);
    setForm(defaultForm);
  };

  return (
    <div className={styles.institutionModalBackdrop} role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className={styles.institutionModalContainer} role="dialog" aria-modal="true" aria-labelledby="inst-title" ref={dialogRef}>
        <div className={styles.institutionModalHeader}>
          <h2 id="inst-title" className={styles.institutionModalTitle}>Registro de Institución</h2>
          <button className={styles.institutionModalClose} aria-label="Cerrar" onClick={onClose}>✕</button>
        </div>
        <form className={styles.institutionModalBody} onSubmit={handleSubmit}>
          <div className={styles.institutionModalGrid}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Nombre de la institución</label>
              <input className={styles.input} name="nombre" value={form.nombre} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Clave</label>
              <input className={styles.input} name="clave" value={form.clave} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Teléfono</label>
              <input className={styles.input} name="telefono" value={form.telefono} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Email Institucional</label>
              <input className={styles.input} type="email" name="email" value={form.email} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Dirección</label>
              <input className={styles.input} name="direccion" value={form.direccion} onChange={handleChange} />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Estado</label>
              <div className={styles.statusSelectWrapper}>
                <span className={`${styles.statusDot} ${form.estado === 'ACTIVO' ? styles.dotGreen : styles.dotRed}`} />
                <select
                  className={`${styles.statusSelect} ${form.estado === 'ACTIVO' ? styles.activeSelect : styles.inactiveSelect}`}
                  name="estado"
                  value={form.estado}
                  onChange={handleChange}
                >
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="INACTIVO">INACTIVO</option>
                </select>
              </div>
            </div>
            <div className={styles.logoGroup}>
              <label className={styles.label}>Logo de la Institución</label>
              <div className={styles.logoDrop} onClick={() => fileInputRef.current?.click()} role="button" tabIndex={0}
                   onKeyDown={(e) => { if (e.key === 'Enter') fileInputRef.current?.click(); }}>
                {logoPreview ? (
                  <>
                    <img src={logoPreview} alt="Logo seleccionado" className={styles.logoPreviewImg} />
                    <button className={styles.logoClear} aria-label="Quitar logo" onClick={handleClearLogo}>✕</button>
                  </>
                ) : (
                  <span className={styles.logoPlus}>+</span>
                )}
              </div>
              <input ref={fileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
            </div>
          </div>
          <div className={styles.institutionModalActions}>
            <button type="submit" className={styles.primaryButton}>GUARDAR</button>
            <button type="button" className={styles.secondaryButton} onClick={onClose}>CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  );
}
